import { render, staticRenderFns } from "./noinotes.vue?vue&type=template&id=5c53704b"
import script from "./noinotes.vue?vue&type=script&lang=js"
export * from "./noinotes.vue?vue&type=script&lang=js"
import style0 from "./noinotes.vue?vue&type=style&index=0&id=5c53704b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports